import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from '../../common';
import { authTokenSelector } from '../../session';
import { RESOURCES, USER_RESOURCE_ENDPOINT } from './endpoints';

const actions = createActions({
  USER: {
    GET_INVOICES: () => ({}),
    API: {
      GET_INVOICES: apiResourceActionCreator('invoices')
    }
  }
})

export const apiAction = (authToken) => commonApiActions.authenticated.get(USER_RESOURCE_ENDPOINT(RESOURCES.Invoices), authToken, actions.user.api.getInvoices)

export function* getInvoices() {
  const authToken = yield select(authTokenSelector);

  if (authToken.idToken) {
    yield put(apiAction(authToken));
  }
}

const configuration = {
  name: 'getInvoices',
  action: actions,
  sagas: getInvoices,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetchingInvoices: true
    }),
    success: (state, action) => ({
      ...state,
      invoices: action.payload.invoices,
      isFetchingInvoices: false
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isFetchingInvoices: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/getInvoices.js